import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_ACCOUNT_SETTINGS_MANAGE_ASSETS_PAGE = defineFcm('account_settings_manage_assets_page')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault({ enabled: false })
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		supportedGroups: { locales: true },
		context: 'Account Settings',
		description:
			'Controls the manage assets page experiment. When set, users are bucketed into the named experiment; control/fake-control variants redirect away from the page.',
		import: false,
		template: {
			enabled: false,
			experimentName: 'account_settings_manage_assets_page',
		},
	});
